import { createClient, type SupabaseClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

/**
 * 26 ADM-001: the console shares no session with the game app. It is served from its own address
 * (its own Cloudflare Pages project), and it keeps its sign-in under its own storage key.
 */
export const ADMIN_AUTH_STORAGE_KEY = 'fairway-life-admin-auth';

export const AUTH_OPTIONS = {
  storageKey: ADMIN_AUTH_STORAGE_KEY,
  persistSession: true,
  autoRefreshToken: true,
  detectSessionInUrl: true,
} as const;

/** null until the staging project's address and public key are set. */
export const supabase: SupabaseClient | null =
  url && anon ? createClient(url, anon, { auth: AUTH_OPTIONS }) : null;
